import { isMobile } from 'react-device-detect';
import { Link, } from "react-router-dom";
import styled from 'styled-components';

const InstituteStatCard = ({ title, value, icon, onClick, style }) => (
  <div className="col-lg-3 col-md-6" style={{paddingRight:".50rem", paddingLeft:".50rem"}}>
    <StyledWrapper onClick={onClick} style={style}>
      <div className="card">
        <div className="bg" />
        <div className="blob" />
        <div className="content" 
        style={{
          flexDirection:isMobile ? "row":"column", 
          justifyContent:isMobile? "space-around":"normal",
          padding:isMobile? 20:0,
          width:"100%"
        }}
        >
          <IconWrapper>
            <i className={icon}></i>
          </IconWrapper>
          <div className="info">
            <h3 className="newfont">{value}</h3>
            <h5 className="newfont">{title}</h5>
          </div>
        </div>
      </div>
    </StyledWrapper>
  </div>
);

export const JobActivityStatCard = ({ title, value, icon, url, style }) => (
  <div className="col-12 col-lg-3 col-md-3" style={{paddingRight:".50rem", paddingLeft:".50rem"}}>
    <StyledWrapper style={style}>
      <Link to={url} >
        <div className="card">
          <div className="bg" />
          <div className="blob" />
          <div className="content" 
          style={{
            flexDirection:isMobile ? "row":"column", 
            justifyContent:isMobile? "space-around":"normal",
            padding:isMobile? 20:0,
            width:"100%"
          }}
          >
            <IconWrapper>
              <i className={icon}></i>
            </IconWrapper>
            <div className="info">
              <h3 className="newfont">{value}</h3>
              <h5 className="newfont">{title}</h5>
            </div>
          </div>
        </div>
      </Link>
    </StyledWrapper>
  </div>
);

const StyledWrapper = styled.div`
  .card {
    position: relative;
    border-radius: 8px;
    z-index: 108;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
    
    &:hover {
      transform: translateY(-2px);
    }
  }

  .bg {
    position: absolute;
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    z-index: 2;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(24px);
    border-radius: 8px;
    overflow: hidden;
    outline: 2px solid white;
  }

  .blob {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    border-radius: 50%;
    background-color: #ffc107;
    opacity: 1;
    filter: blur(12px);
    animation: blob-bounce 5s infinite ease;
    aspect-ratio: 1;
    min-width: 100%;
  }

  @keyframes blob-bounce {
    0% {
      transform: translate(-100%, -100%) translate3d(0, 0, 0);
    }
    25% {
      transform: translate(-100%, -100%) translate3d(100%, 0, 0);
    }
    50% {
      transform: translate(-100%, -100%) translate3d(100%, 100%, 0);
    }
    75% {
      transform: translate(-100%, -100%) translate3d(0, 100%, 0);
    }
    100% {
      transform: translate(-100%, -100%) translate3d(0, 0, 0);
    }
  }

  .content {
    position: relative;
    z-index: 3;
    display: flex;
    align-items: center;
    text-align: center;
    gap: 1rem;
  }

  .info {
    h5 {
      font-size: 1.2rem;
      font-weight: 500;
      color: #1a1a1a;
      margin: 0;
      line-height: 1.5;
      letter-spacing: 0.02em;
      min-height: 48px;
    }

    h3 {
      font-size: 2.3rem;
      font-weight: 700;
      margin: 0;
      letter-spacing: -0.03em;
      color: ${props => props.color || '#000'};
      margin-bottom: 1rem;
    }
  }
`;

const IconWrapper = styled.div`
  font-size: 40px;
  color: white;
  background: linear-gradient(135deg, #ffcf57, #ffb347);
  padding: 15px;
  margin-top: 10px;
  border-radius: 50%;
  margin-bottom: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  min-width: 90px;
  position: relative;
  z-index: 3;
`;

export default InstituteStatCard;